import { render, staticRenderFns } from "./RefundDetail.vue?vue&type=template&id=cef2dc6c&scoped=true&"
import script from "./RefundDetail.vue?vue&type=script&lang=js&"
export * from "./RefundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef2dc6c",
  null
  
)

export default component.exports